export default "__VITE_ASSET__DTimA3Ix__"